module.exports = __webpack_public_path__ + "media/images/flags/1x1/som-e38d10b128d9f8e212fc50365268aea1.svg";